import Interests from "utils/Interests"
import L10n from "../lib/carrot-l10n"
import { BenefitConfiguration } from "types/benefitConfiguration"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

type InterestChoice = {
  labelKey: string
  id: Interests
  filter?: (config: BenefitConfiguration) => boolean
  pronouns?: {
    singular: string
    plural: string
  }
}

const InterestChoices: InterestChoice[] = [
  {
    labelKey: "fle2.interestchoice.understandmyfertility",
    id: Interests.UNDERSTAND_MY_FERTILITY,
    pronouns: {
      singular: "my",
      plural: "our"
    }
  },
  {
    labelKey: "fle2.interestchoice.initialfertilitytesting",
    id: Interests.INITIAL_FERTILITY_TESTING
  },
  {
    labelKey: "fle2.interestchoice.embryofreezing",
    id: Interests.EMBRYO_FREEZING
  },
  { labelKey: "fle2.interestchoice.eggfreezing", id: Interests.EGG_FREEZING },
  {
    labelKey: "fle2.interestchoice.spermfreezing",
    id: Interests.SPERM_FREEZING
  },
  { labelKey: "fle2.interestchoice.ivf", id: Interests.IVF },
  { labelKey: "fle2.interestchoice.iui", id: Interests.IUI },
  {
    labelKey: "fle2.interestchoice.adopting",
    id: Interests.ADOPTING,
    filter: (config) => config.featureConfig.isAdoptionEnabled
  },
  {
    labelKey: "fle2.interestchoice.gestationalcarrier",
    id: Interests.GESTATIONAL_CARRIER,
    filter: (config) => config.featureConfig.isGcEnabled
  },
  {
    labelKey: "fle2.interestchoice.somethingelse",
    id: Interests.SOMETHING_ELSE
  },
  {
    labelKey: l`Pregnancy`,
    id: Interests.PREGNANCY
  }
]

const GetInterestChoices = () => {
  return InterestChoices
}

export default GetInterestChoices
